<template>
  <v-card flat outlined>
    <v-toolbar flat color="primary" dark dense>
      <v-toolbar-title>{{ $translate('CUSTOMERS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="isShoppingListAdmin(shoppingList)" icon @click="onAddUser">
        <v-icon>person_add_alt_1</v-icon>
      </v-btn>
      <v-btn v-else @click="onLeaveList">
        {{ $translate('LEAVE') }}
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-chip-group
        v-if="isShoppingListAdmin(shoppingList)"
        active-class="primary--text"
        column
      >
        <v-chip
          v-for="(mail, mailIndex) in shoppingList.Users"
          :key="mailIndex"
          close
          @click:close="onDeleteUser(mail)"
        >
          {{ mail.Email }}
        </v-chip>
      </v-chip-group>
      <v-chip-group v-else active-class="primary--text" column>
        <v-chip
          v-for="(mail, mailIndex) in shoppingList.Users"
          :key="mailIndex"
        >
          {{ mail.Email }}
        </v-chip>
      </v-chip-group>
    </v-card-text>
  </v-card>
</template>

<script>
import { isShoppingListAdmin } from '@/objects/ShoppingList';

export default {
  name: 'ShoppingListUsers',
  props: {
    shoppingList: Object,
  },
  emits: ['add-user', 'delete-user', 'leave'],
  computed: {
    userId() {
      return this.$store.getters['auth/userName'];
    },
  },
  methods: {
    isShoppingListAdmin,
    onAddUser() {
      this.$emit('add-user');
    },
    onDeleteUser(userInfo) {
      this.$emit('delete-user', userInfo);
    },
    onLeaveList() {
      this.$emit('leave');
    },
  },
};
</script>
